<ion-app id="ion-app" [ngClass]="{'pc-width':platformchk.isPcWeb}">
  <ion-router-outlet animated="true"></ion-router-outlet>
</ion-app>
